import RedeemRequest from '../Redeem/RedeemRequest'

const isActiveRequest = (request: RedeemRequest) =>
  request && (request.status === 'requested' || request.status === 'authorized')

export default isActiveRequest
